import { ADOnPremSensorComponent } from '../component/ADOnPremSensorComponent';
import { templateADOnPrem } from '../view/template';
import { BaseSensorWebComponent } from '../../base/BaseSensorWebComponent';
import { ADOnPremSensorView } from '../view/ADOnPremSensorView';
import { BaseWebComponentController } from '../../../../framework/BaseWebComponentController';
import { SensorEvent } from '../../types/sensor-type';

export class ADOnPremSensorController extends BaseWebComponentController {
  public component: BaseSensorWebComponent;
  public view: ADOnPremSensorView;
  public viewConstructor: typeof ADOnPremSensorView;

  constructor(component: ADOnPremSensorComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: ADOnPremSensorView,
      viewTemplate: templateADOnPrem,
    });
  }

  public resetData(): void {
    this.component.setSensorId(null);
    this.view.resetData();
  }

  public inputChanged(ev): void {
    this.dispatchSensorEvent(SensorEvent.change, {
      type: this.component.getSensorType(),
      sourceEvent: ev.detail.sourceEvent,
    });
  }

  private dispatchSensorEvent(eventName: SensorEvent, details: Object): void {
    this.component.dispatchEvent(
      new CustomEvent(eventName, {
        detail: details,
        bubbles: true,
        composed: true,
      })
    );
  }

  public isSensorEnabled(): boolean {
    return true;
  }

  async getDataForView(): Promise<any> {
    if (!this.component.getSensorId()) {
      return {};
    }
    const data = await this.dependencies.api.clients.SensorsIntegrations.getSensorById({
      sensorId: this.component.getSensorId(),
    });
    return data;
  }

  private async getDomains() {
    const domains = await this.dependencies.api.clients.SensorsIntegrations.getDomains();
    return domains['data'];
  }

  public getSensorName(): string {
    return '';
  }
}
